import React, { useEffect, useState, useRef } from 'react';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import bgimage from '../../../../images/default_staff.png';
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import "react-dropzone-uploader/dist/styles.css";
import FileUpload from "react-material-file-upload";
import DatePicker, { DateObject } from "react-multi-date-picker";
import swal from "sweetalert2";
import axios from 'axios';

// import DropFile from "./DropFile";
const AddStaff = ({ onClose }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // Required fields
    const [manageStaffTypeId, setManageStaffTypeId] = useState("0");
    const [existingManagestaff, setExistingManagestaff] = useState([]);
    const [manageStaffType, setManageStaffType] = useState('');
    const [employeeName, setEmployeeName] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [gender, setGender] = useState('0'); // 0,1,2
    const [mailId, setMailId] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [alternatePhoneNo, setAlternatePhoneNo] = useState('');
    const [contactPerson, setContactPerson] = useState('');
    const [contactPersonPhoneNo, setContactPersonPhoneNo] = useState('');
    const [educationLevel, setEducationLevel] = useState('');
    const [selectedExperience, setSelectedExperience] = useState('fresher');
    const [workExperience, setWorkExperience] = useState('');
    const [experienceLevel, setExperienceLevel] = useState('');
    const [selectExperience, setSelectExperience] = useState('');
    const [address, setAddress] = useState('');
    const [pincode, setPincode] = useState('');
    const [dateOfJoining, setDateOfJoining] = useState(null);
    const [department, setDepartment] = useState([]);
    const [jobRole, setJobRole] = useState([]);
    const [position, setPosition] = useState('');
    const [salary, setSalary] = useState('');
    const [hour_cost, setHourCost] = useState('');
    const [shiftTime, setShiftTime] = useState([]);
    const [role, setRole] = useState([]);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [bankName, setBankName] = useState('');
    const [branchName, setBranchName] = useState('');
    const [accountHolderName, setAccountHolderName] = useState('');
    const [accountNo, setAccountNo] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [description, setDescription] = useState('');
    const [branchOptions, setBranchOptions] = useState([]);
    const [franchiseOptions, setFranchiseOptions] = useState([]);
    const [errors, setErrors] = useState({});
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedFranchise, setSelectedFranchise] = useState(null);
    const [selectedEducationLevel, setSelectedEducationLevel] = useState(null);
    const [selectedExperienceUnit, setSelectedExperienceUnit] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedJobRole, setSelectedJobRole] = useState(null);
    const [selectedShiftTime, setSelectedShiftTime] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const [staffImageFile, setStaffImageFile] = useState(null);

    const [curent_branch, setBrnch] = useState("");
    useEffect(() => {
        axios.get(`${baseURL}/managebranch/${branch_id}`)
            .then(response => {
                setManageStaffTypeId(String(response.data.data.manage_branch_type));
                setBrnch(response.data.data.branch_name);
                if (response.data.data.manage_branch_type === 0) {
                    setSelectedBranch(response.data.data.sno);
                } else if (response.data.data.manage_branch_type === 1) {
                    setSelectedFranchise(response.data.data.sno);
                }
            })
            .catch(error => {
                console.log("Error fetching manage staff data", error);
            });
    }, []);

    const [existingManageStaffData, setExistingManageStaffData] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/managestaff`)
            .then(response => {
                setExistingManageStaffData(response.data.data || []);
            })
            .catch(error => {
                console.log("Error fetching manage staff data", error);
            });
    }, []);

    useEffect(() => {
        axios.get(`${baseURL}/managebranch`)
            .then((response) => {
                const data = response.data.data.data || []; // response.data.data is already the array
                // console.log("Raw branch data:", data);

                // Adjusting for correct key: `manage_branch_type` not `type`
                const branches = data
                    .filter(item => item.manage_branch_type == 0)
                    .map(item => ({
                        value: item.sno.toString(), // or item.manage_branch_id if needed
                        label: item.branch_name,
                    }));

                const franchises = data
                    .filter(item => item.manage_branch_type == 1)
                    .map(item => ({
                        value: item.sno.toString(),
                        label: item.branch_name,
                    }));

                // console.log("Formatted branches:", branches);
                setBranchOptions(branches);
                setFranchiseOptions(franchises);
            })
            .catch((error) => {
                console.log("Error fetching branch/franchise data", error);
            });
    }, []);


    useEffect(() => {
        axios.get(`${baseURL}/department`)
            .then(res => {
                // console.log("API Response:", res.data);
                const data = res.data?.data || [];
                const formatted = data.filter(role => role.status == 0).map(department => ({
                    value: department.sno,
                    label: department.department_name
                }));
                // console.log("Formatted Options:", formatted);
                setDepartment(formatted);
            })
            .catch(err => {
                console.log("Error loading department", err);
                setDepartment([]);
            });
    }, []);

    useEffect(() => {
        axios.get(`${baseURL}/jobrole`)
            .then(res => {
                // console.log("Job Role API Response:", res.data);
                const data = res.data?.data || [];

                const formatted = data.filter(role => role.status == 0).map(role => ({
                    value: role.sno,
                    label: role.jobrole_name
                }));

                // console.log("Formatted Job Roles:", formatted);
                setJobRole(formatted);
            })
            .catch(err => {
                console.log("Error loading job roles", err);
                setJobRole([]);
            });
    }, []);

    useEffect(() => {
        axios.get(`${baseURL}/shifttime`)
            .then(res => {
                // console.log("Shift Time API Response:", res.data);
                const data = res.data?.data || [];
                const formatted = data.filter(role => role.status == 0).map(shift => ({
                    value: shift.sno, // adjust to your API field
                    label: shift.shifttime_name // or whatever field you use
                }));
                setShiftTime(formatted);
            })
            .catch(err => {
                console.log("Error loading shift time", err);
                setShiftTime([]);
            });
    }, []);

    useEffect(() => {
        const params = { branch_id: branch_id };
        axios.get(`${baseURL}/manageuser/active`, { params: params })
            .then(res => {
                // console.log("Role API Response:", res.data);
                const data = res.data?.data || [];
                const formatted = data.map(role => ({
                    value: role.sno, // adjust if your API uses a different field
                    label: role.user_role_name // adjust field name based on API response
                }));
                setRole(formatted);
            })
            .catch(err => {
                console.log("Error loading roles", err);
                setRole([]);
            });
    }, []);


    const [files, setFiles] = useState([]);
    const [fileerrors, setfileErrors] = useState([]);
    const handleFileChange = (newFiles) => {
        const maxFileSize = 5 * 1024 * 1024; // 5MB
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/gif",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        const newErrors = [];
        const validFiles = newFiles.filter((file) => {
            if (!allowedTypes.includes(file.type)) {
                newErrors.push(`"${file.name}" is not a supported file type.`);
                return false;
            }
            if (file.size > maxFileSize) {
                newErrors.push(`"${file.name}" exceeds 5MB.`);
                return false;
            }
            return true;
        });
        setfileErrors(newErrors);
        setFiles(validFiles);
    };


    const genders = [
        { value: "0", label: "Male" },
        { value: "1", label: "Female" },
        { value: "2", label: "Others" }
    ];

    const educational_level = [
        { value: "0", label: "10th", },
        { value: "1", label: "12th" },
        { value: "2", label: "Diploma", },
        { value: "3", label: "UG", },
        { value: "4", label: "PG" },
    ];

    const experience_e = [
        { value: "0", label: "Month", },
        { value: "1", label: "Years" }
    ];

    const experience_type = [
        { value: "fresher", label: "Fresher" },
        { value: "experience", label: "Experience" },
    ];

    // const [selectedOption, setSelectedOption] = useState(null);
    const [file, setFile] = React.useState(null)
    const imageInputRef = useRef(null);
    const fileHandler = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setStaffImageFile(selectedFile);
        }
    }
    const RemoveImage = () => {
        setFile(null);
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };

    const [showBlock, setShowBlock] = useState({
        Experience: false
        // fresher: false
    });
    const DivExperience = (value) => {
        setSelectedExperience(value);
        setShowBlock({ Experience: value === 'experience' });
        if (value === 'fresher') {
            setWorkExperience('');
            setSelectedExperienceUnit(null);
        }
    };
    const handleCheckboxChangebank = () => {
        setBankDetails(!bankDetails);
    };

    const [bankDetails, setBankDetails] = useState(false);

    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };

    const handleRadioChange = (event) => {
        setManageStaffTypeId(event.target.value);
    };

    const validateForm = () => {
        const newErrors = {};

        const lowerCaseName = employeeName.trim().toLowerCase();
        const lowerCaseEmail = mailId.trim().toLowerCase();

        if (manageStaffTypeId === "0" && !selectedBranch) {
            newErrors.branch = "Branch is required";
        }
        if (manageStaffTypeId === "1" && !selectedFranchise) {
            newErrors.franchise = "Franchise is required";
        }
        // if(!manageStaffType.trim()) newErrors.manageStaffType = "This Field is required";
        if (!employeeName.trim()) newErrors.employeeName = "This Field is required";
        if (!dateOfBirth) newErrors.dateOfBirth = "This Field is required";
        if (!gender) newErrors.gender = "This Field is required";
        if (!mailId.trim()) {
            newErrors.mailId = "This Field is required";
        } else if (!/^\S+@\S+\.\S+$/.test(mailId)) {
            newErrors.mailId = "Invalid email format";
        }
        if (!phoneNo.trim()) {
            newErrors.phoneNo = "This Field is required";
        } else if (!/^\d{10}$/.test(phoneNo)) {
            newErrors.phoneNo = "Phone number must be 10 digits";
        }
        if (alternatePhoneNo && !/^\d{10}$/.test(alternatePhoneNo)) {
            newErrors.alternatePhoneNo = "Alternate number must be 10 digits";
        }

        // contact person name
        if (!contactPerson.trim()) {
            newErrors.contactPerson = "This Field is required";
        } else if (contactPerson.trim().toLowerCase() === lowerCaseName) {
            newErrors.contactPerson = "Contact person name must differ from employee name";
        }


        if (!contactPersonPhoneNo.trim()) {
            newErrors.contactPersonPhoneNo = "This Field is required";
        } else if (!/^\d{10}$/.test(contactPersonPhoneNo)) {
            newErrors.contactPersonPhoneNo = "Contact phone must be 10 digits";
        }
        if (!selectedEducationLevel) newErrors.educationLevel = "This Field is required";
        if (selectedExperience === "experience") {
            if (!workExperience) newErrors.workExperience = "This Field is required";
            if (!selectedExperienceUnit) newErrors.experienceLevel = "This Field is required";
        }
        if (!address.trim()) newErrors.address = "This Field is required";
        if (!pincode.trim()) {
            newErrors.pincode = "This Field is required";
        } else if (!/^\d{6}$/.test(pincode)) {
            newErrors.pincode = "Pincode must be 6 digits";
        }
        if (!dateOfJoining) newErrors.dateOfJoining = "This Field is required";
        if (!selectedDepartment) newErrors.department = "This Field is required";
        if (!selectedJobRole) newErrors.jobRole = "This Field is required";
        if (!position.trim()) newErrors.position = "This Field is required";
        if (!salary.trim()) newErrors.salary = "This Field is required";
        if (!hour_cost.trim()) newErrors.hr_cost = "This Field is required";
        if (!selectedShiftTime) newErrors.shiftTime = "This Field is required";

        if (isChecked) {
            if (!selectedRole) newErrors.role = "This Field is required";
            if (!userName.trim()) newErrors.userName = "This Field is required";
            if (!password.trim()) newErrors.password = "This Field is required";
        }
        if (bankDetails) {
            if (!bankName.trim()) newErrors.bankName = "This Field is required";
            if (!branchName.trim()) newErrors.branchName = "This Field is required";
            if (!accountHolderName.trim()) newErrors.accountHolderName = "This Field is required";
            if (!accountNo.trim()) newErrors.accountNo = "This Field is required";
            if (!ifscCode.trim()) {
                newErrors.ifscCode = "This Field is required";
            }
        }

        // Duplicate checks


        const isDuplicateEmail = existingManageStaffData.some(
            (staff) => staff.mail_id?.toLowerCase() === lowerCaseEmail
        );

        const isDuplicatePhone = existingManageStaffData.some(
            (staff) =>
                staff.phone_no?.toString() === phoneNo ||
                staff.alternate_phone_no?.toString() === phoneNo ||
                staff.contact_person_phone_no?.toString() === phoneNo
        );

        const isDuplicateAltPhone = alternatePhoneNo && existingManageStaffData.some(
            (staff) =>
                staff.phone_no?.toString() === alternatePhoneNo ||
                staff.alternate_phone_no?.toString() === alternatePhoneNo ||
                staff.contact_person_phone_no?.toString() === alternatePhoneNo
        );

        const isDuplicateContactPhone = contactPersonPhoneNo && existingManageStaffData.some(
            (staff) =>
                staff.phone_no?.toString() === contactPersonPhoneNo ||
                staff.alternate_phone_no?.toString() === contactPersonPhoneNo ||
                staff.contact_person_phone_no?.toString() === contactPersonPhoneNo
        );

        const isDuplicateName = existingManageStaffData.some(
            (staff) => staff.employee_name?.toLowerCase() === lowerCaseName
        );

        // const isSameAsContactPersonName = contactPerson.trim().toLowerCase() === lowerCaseName;

        if (isDuplicateEmail) newErrors.mailId = "Email is already in use";
        if (isDuplicatePhone) newErrors.phoneNo = "Mobile number is already in use";
        if (isDuplicateAltPhone) newErrors.alternatePhoneNo = "Alternate number is already in use";
        if (isDuplicateContactPhone) newErrors.contactPersonPhoneNo = "Contact person number is already in use";
        if (isDuplicateName) newErrors.employeeName = "Employee name already exists";
        // if (isSameAsContactPersonName) newErrors.contactPerson = "Contact person name must differ from employee name";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = validateForm();
        if (!isValid) return;

        const formData = new FormData();
        formData.append("created_by", user_id);
        formData.append("manage_staff_type_id", manageStaffTypeId);
        formData.append("manage_staff_type", manageStaffTypeId === "0" ? selectedBranch : selectedFranchise);
        formData.append("employee_name", employeeName);
        // formData.append("date_of_birth", dateOfBirth);
        formData.append("date_of_birth", dateOfBirth ? dateOfBirth.format("YYYY-MM-DD") : "");
        formData.append("gender", gender);
        formData.append("mail_id", mailId);
        formData.append("phone_no", phoneNo);
        formData.append("alternate_phone_no", alternatePhoneNo || '');
        formData.append("contact_person", contactPerson);
        formData.append("contact_person_phone_no", contactPersonPhoneNo);
        formData.append("address", address);
        formData.append("pincode", pincode);
        formData.append("date_of_joining", dateOfJoining ? dateOfJoining.format("YYYY-MM-DD") : "");
        formData.append("position", position);
        formData.append("salary", salary);
        formData.append("per_hour_cost", hour_cost);

        formData.append("bank_details", bankDetails ? "1" : "0");
        formData.append("bank_name", bankName);
        formData.append("branch_name", branchName);
        formData.append("account_holder_name", accountHolderName);
        formData.append("account_no", accountNo);
        formData.append("ifsc_code", ifscCode);
        formData.append("description", description || '');
        formData.append("education_level", selectedEducationLevel?.value || '');
        if (selectedExperience === 'experience') {
            formData.append("experience_level", 1);
            formData.append("select_experience", selectedExperienceUnit?.value || '');
            formData.append("work_experience", workExperience || "");
        } else {
            formData.append("experience_level", 0);
            formData.append("work_experience", "");
            formData.append("select_experience", "");
        }

        if (isChecked) {
            formData.append("login_information", 1);
            formData.append("user_name", userName || '');
            formData.append("password", password || '');
            formData.append("role", selectedRole?.value || '');
        } else {
            formData.append("login_information", 0);
        }

        // formData.append("experience_level", selectedExperienceUnit?.value || '');
        formData.append("department", selectedDepartment?.value || '');
        formData.append("job_role", selectedJobRole?.value || '');
        formData.append("shift_time", selectedShiftTime?.value || '');

        if (staffImageFile) formData.append("staff_image", staffImageFile);
        // files.forEach((file, index) => formData.append(`attachments[]`, file));
        // Single image file
        if (file) {
            formData.append("staff_image", file);
        }

        // Multiple attachments
        if (files && files.length > 0) {
            files.forEach((file, index) => {
                formData.append(`attachments[]`, file);
            });
        }

        try {
            const response = await axios.post(`${baseURL}/managestaff`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            if (response.status === 201) {
                swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Staff created successfully.",
                }).then(() => {
                    if (typeof onClose === "function") {
                        onClose(); // Only call onClose if it's a function
                    }
                    window.location.href = "./manage-staff";
                });
            }
        } catch (error) {
            swal.fire({
                icon: "error",
                title: "Submission Failed",
                text: error.response?.data?.message || "An error occurred.",
            });
        }
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 mb-4">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Add Staff</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">HR Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-staff'>Manage Staff</Link></li>
                    </ol>
                </div>
            </div>

            <label className='text-red fs-4 font-w600 mb-3'>Basic Information</label>
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">{manageStaffTypeId === "0" ? 'Branch' : 'Franchise'}<span className="required">*</span></label>
                    <label className="col-12 text-red font-w500 fs-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{curent_branch}</label>
                    {/* <div className='mt-2'>
                        <div className="form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="brnchfrnch"
                                value="0"
                                // defaultChecked
                                checked={manageStaffTypeId === "0"}
                                onChange={handleRadioChange}
                                readOnly
                            />
                            <label className="form-check-label fs-7">
                                Branch
                            </label>
                        </div>
                        <div className="form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="brnchfrnch"
                                value="1"
                                checked={manageStaffTypeId === "1"}
                                onChange={handleRadioChange}
                                readOnly
                            />
                            <label className="form-check-label fs-7">
                                Franchise
                            </label>
                        </div>
                    </div> */}
                </div>
                {/* {manageStaffTypeId === "0" && (
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Branch<span className="required">*</span></label>
                        <Select placeholder='Select Branch'
                            value={selectedBranch}
                            onChange={setSelectedBranch}
                            options={branchOptions}
                            
                        />
                        {errors.branch && <span className="text-danger">{errors.branch}</span>}
                    </div>
                )}
                {manageStaffTypeId === "1" && (
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Franchise<span className="required">*</span></label>
                        <Select placeholder='Select Franchise'
                            value={selectedFranchise}
                            onChange={setSelectedFranchise}
                            options={franchiseOptions}
                        />
                        {errors.franchise && <span className="text-danger">{errors.franchise}</span>}
                    </div>
                )} */}
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Employee Name <span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Employee Name"
                        value={employeeName}
                        onChange={(e) => {
                            setEmployeeName(e.target.value);
                        }} />
                    {errors.employeeName && <span className="text-danger">{errors.employeeName}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Date of Birth<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker
                            value={dateOfBirth}
                            onChange={(date) => setDateOfBirth(date)}
                            format="DD-MM-YYYY"
                            placeholder='Select Date of Birth'
                            maxDate={new Date(new Date().setHours(23, 59, 59, 999))}
                        />
                    </div>
                    {errors.dateOfBirth && <span className="text-danger">{errors.dateOfBirth}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Gender<span className="required">*</span></label>
                    <div className='mt-2'>
                        {genders.map((g) => (
                            <div className="form-check-inline" key={g.value}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="product_type"
                                    value={g.value}
                                    checked={gender === g.value}
                                    onChange={(e) => setGender(e.target.value)}
                                />
                                <label className="form-check-label fs-7">
                                    {g.label}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Mail ID<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Mail ID"
                        value={mailId}
                        onChange={(e) => {
                            setMailId(e.target.value);
                            // setUserName(e.target.value);
                        }} />
                    {errors.mailId && <span className="text-danger">{errors.mailId}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Phone No<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Phone No"
                        value={phoneNo}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only digits and limit to 10 characters
                            if (/^\d*$/.test(value) && value.length <= 10) {
                                setPhoneNo(value);
                            }
                        }} />
                    {errors.phoneNo && <span className="text-danger">{errors.phoneNo}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Alternate Phone No</label>
                    <input type="text" className="form-control" placeholder="Enter Alternate Phone No"
                        value={alternatePhoneNo}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only digits and limit to 10 characters
                            if (/^\d*$/.test(value) && value.length <= 10) {
                                setAlternatePhoneNo(value);
                            }
                        }} />
                    {errors.alternatePhoneNo && <span className="text-danger">{errors.alternatePhoneNo}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Contact Person<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Contact Person"
                        value={contactPerson}
                        onChange={(e) => setContactPerson(e.target.value)} />
                    {errors.contactPerson && <span className="text-danger">{errors.contactPerson}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Contact Person Phone No<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Contact Person Phone No"
                        value={contactPersonPhoneNo}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only digits and limit to 10 characters
                            if (/^\d*$/.test(value) && value.length <= 10) {
                                setContactPersonPhoneNo(value);
                            }
                        }} />
                    {errors.contactPersonPhoneNo && <span className="text-danger">{errors.contactPersonPhoneNo}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Educational Level<span className="required">*</span></label>
                    <Select placeholder='Select Educational Level'
                        value={selectedEducationLevel}
                        onChange={setSelectedEducationLevel}
                        options={educational_level}
                    />
                    {errors.educationLevel && <span className="text-danger">{errors.educationLevel}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Experience Level <span className="required">*</span></label>
                    <div className='mt-2'>
                        {experience_type.map(({ value, label }) => (
                            <div className="form-check-inline" key={value}>
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="employee"
                                    value={value}
                                    checked={selectedExperience === value}
                                    onChange={() => DivExperience(value)}
                                />
                                <label className="form-check-label fs-7">
                                    {label}
                                </label>
                            </div>
                            // <div className="form-check-inline">
                            //     <input
                            //         className="form-check-input"
                            //         type="radio"
                            //         name="employee"
                            //         value="experience"
                            //         onClick={() => DivExperience('Experience')}
                            //     />
                            //     <label className="form-check-label fs-7">
                            //         Experience
                            //     </label>
                            // </div>
                        ))}
                    </div>
                </div>
                {showBlock.Experience && (
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Work Experience<span className="required">*</span></label>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <input type="text" className="form-control" placeholder="Enter Work Experience"
                                    value={workExperience}
                                    // onChange={(e) => setWorkExperience(e.target.value)}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setWorkExperience(onlyNums);
                                    }}
                                />
                            </div>
                            <div className='col-lg-6'>
                                <Select placeholder='Select Experience'
                                    value={selectedExperienceUnit}
                                    onChange={setSelectedExperienceUnit}
                                    options={experience_e}
                                />
                                {errors.experience_level && <span className="text-danger">{errors.experience_level}</span>}
                            </div>
                        </div>
                    </div>
                )}
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Address<span className="required">*</span></label>
                    <textarea rows={4} className="form-control" name="comment" placeholder="Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)} />
                    {errors.address && <span className="text-danger">{errors.address}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Pincode<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Pincode"
                        value={pincode}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only digits, max length 6
                            if (/^\d*$/.test(value) && value.length <= 6) {
                                setPincode(value);
                            }
                        }} />
                    {errors.pincode && <span className="text-danger">{errors.pincode}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Staff Image</label>
                    <div className="avatar-upload d-flex align-items-center">
                        <div className="change position-relative">
                            <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                <img
                                    id="saveImageFile"
                                    src={file ? URL.createObjectURL(file) : bgimage}
                                    alt={file ? file.name : 'Default Avatar'}
                                    className="p-1 h-125px w-125px"
                                />
                            </div>
                            <div className="change-btn">
                                <input
                                    type="file"
                                    id="imageUpload"
                                    accept=".png, .jpg, .jpeg"
                                    style={{ display: 'none' }}
                                    onChange={fileHandler}
                                    ref={imageInputRef}
                                />
                                <div className="mt-2 d-flex justify-content-center gap-3">
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="success"
                                        onClick={() => imageInputRef.current.click()}
                                    >
                                        <span className="">
                                            <i className="fa fa-upload color-success fs-5" />
                                        </span>
                                    </Button>
                                    <Button
                                        className="btn-xs mb-2"
                                        variant="danger"
                                        onClick={RemoveImage}
                                    >
                                        <span className="">
                                            <i className="fa fa-close color-danger fs-5" />
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <label className='text-red fs-4 font-w600 mb-3'>Designation Information</label>
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Date of Joining <span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker
                            value={dateOfJoining}
                            onChange={(date) => setDateOfJoining(date)}
                            format="DD-MM-YYYY"
                            placeholder='Select Date of Joining'
                        />
                    </div>
                    {errors.dateOfJoining && <span className="text-danger">{errors.dateOfJoining}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Department <span className="required">*</span></label>
                    <Select placeholder='Select Department'
                        value={selectedDepartment}
                        onChange={setSelectedDepartment}
                        options={department}
                    />
                    {errors.department && <span className="text-danger">{errors.department}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Job Role <span className="required">*</span></label>
                    <Select placeholder='Select Job Role'
                        value={selectedJobRole}
                        onChange={setSelectedJobRole}
                        options={jobRole}
                    />
                    {errors.jobRole && <span className="text-danger">{errors.jobRole}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Position<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Position"
                        value={position}
                        onChange={(e) => setPosition(e.target.value)} />
                    {errors.position && <span className="text-danger">{errors.position}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Salary<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Salary"
                        value={salary}
                        // onChange={(e) => setSalary(e.target.value)}
                        maxLength={10}
                        onChange={(e) => {
                            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                            setSalary(onlyNums);
                        }}
                    />
                    {errors.salary && <span className="text-danger">{errors.salary}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Per Hour Cost<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Per Hour Cost"
                        value={hour_cost}
                        maxLength={10}
                        onChange={(e) => {
                            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                            setHourCost(onlyNums);
                        }}
                    />
                    {errors.hr_cost && <span className="text-danger">{errors.hr_cost}</span>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 fs-7">Shift Time<span className="required">*</span></label>
                    <Select placeholder='Select Shift Time'
                        value={selectedShiftTime}
                        onChange={setSelectedShiftTime}
                        options={shiftTime}
                    />
                    {errors.shiftTime && <span className="text-danger">{errors.shiftTime}</span>}
                </div>
            </div>

            {/* login information */}
            <div className="form-check custom-checkbox">
                <input
                    type="checkbox"
                    onChange={handleCheckboxChange}
                    className="form-check-input me-3"
                    id="customCheckBox1"
                    required
                />
                <label className="text-red fs-4 font-w600 mb-3" htmlFor="customCheckBox1">Login Information</label>
            </div>
            {isChecked && (
                <div className='row'>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">User Name<span className="required">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            value={userName}
                            // onChange={(e) => setUserName(e.target.value)}
                            onChange={(e) => {
                                const onlyNums = e.target.value.replace(/[^0-9a-zA-Z]/g, '');
                                setUserName(onlyNums);
                            }}
                            placeholder="Enter User Name"
                        />
                        {errors.userName && <span className="text-danger">{errors.userName}</span>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Password<span className="required">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter Password"
                        />
                        {errors.password && <span className="text-danger">{errors.password}</span>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Role <span className="required">*</span></label>
                        <Select placeholder='Select Role'
                            value={selectedRole}
                            onChange={setSelectedRole}
                            options={role}
                        />
                        {errors.role && <span className="text-danger">{errors.role}</span>}
                    </div>
                </div>
            )}

            {/* Bank information */}
            <div className="form-check custom-checkbox">
                <input
                    type="checkbox"
                    checked={bankDetails}
                    onChange={handleCheckboxChangebank}
                    className="form-check-input me-3"
                    id="customCheckBox1"
                    required

                />
                <label className="text-red fs-4 font-w600 mb-3" htmlFor="customCheckBox1">Bank Information</label>
            </div>
            {bankDetails && (
                <div className='row'>
                    <div className="col-lg-4  mb-4">
                        <label className="text-black font-w500 fs-7">Bank Name<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Bank Name "
                            value={bankName}
                            onChange={(e) => setBankName(e.target.value)} />
                        {errors.bankName && <span className="text-danger">{errors.bankName}</span>}
                    </div>
                    <div className="col-lg-4  mb-4">
                        <label className="text-black font-w500 fs-7">Branch Name<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Bank Branch"
                            value={branchName}
                            onChange={(e) => setBranchName(e.target.value)} />
                        {errors.branchName && <span className="text-danger">{errors.branchName}</span>}
                    </div>
                    <div className="col-lg-4  mb-4">
                        <label className="text-black font-w500 fs-7">Account Holder Name<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Account Holder Name"
                            value={accountHolderName}
                            maxLength={150}
                            onChange={(e) => setAccountHolderName(e.target.value)} />
                        {errors.accountHolderName && <span className="text-danger">{errors.accountHolderName}</span>}
                    </div>
                    <div className="col-lg-4  mb-4">
                        <label className="text-black font-w500 fs-7">Account No<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Account No"
                            value={accountNo}
                            maxLength={25}
                            onChange={(e) => setAccountNo(e.target.value)} />
                        {errors.accountNo && <span className="text-danger">{errors.accountNo}</span>}
                    </div>
                    <div className="col-lg-4  mb-4">
                        <label className="text-black font-w500 fs-7">IFSC Code<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter IFSC Code "
                            value={ifscCode}
                            onChange={(e) => setIfscCode(e.target.value)} />
                        {errors.ifscCode && <span className="text-danger">{errors.ifscCode}</span>}
                    </div>

                </div>
            )}

            <div className='row'>
                <div className='col-lg-6 mb-4'>
                    <label className="text-black font-w500 fs-7">Attachment</label>
                    <OverlayTrigger trigger={['hover', 'click']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>File Type: jpg, png, pdf, docx<br></br>Maximun File Size: 5Mb</span></Tooltip>} >
                        <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                            <span><i class="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                        </Button>
                    </OverlayTrigger>
                    <div className='mt-2'>
                        <FileUpload
                            maxFiles={4}
                            value={files}
                            onChange={handleFileChange}
                        />
                    </div>
                    {fileerrors.length > 0 && (
                        <div className="text-danger mt-2">
                            {fileerrors.map((error, index) => (
                                <div key={index}>{error}</div>
                            ))}
                        </div>
                    )}
                </div>
                <div className='col-lg-6 mt-1'>
                    <label className="text-black font-w500 fs-7">Description</label>
                    <textarea rows={6} className="form-control h-auto" name="comment" placeholder="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)} />
                </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={'/manage-staff'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                <button onClick={handleSubmit} type="submit" className="btn btn-sm btn-primary">Create Staff</button>
            </div>
        </>
    )


}
export default AddStaff;